// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import * as types from './actionTypes';

export function startLoader() {
  return {
    type: types.CUSTOMER_OVERVIEW_START_LOADER,
  };
}

export function stopLoader() {
  return {
    type: types.CUSTOMER_OVERVIEW_STOP_LOADER,
  };
}

export function getBookshopCustomer(payload) {
  return {
    type: types.CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER,
    payload,
  };
}

export function getBookshopCustomerSuccess(payload) {
  return {
    type: types.CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER_SUCCESS,
    payload
  };
}

export function changeRedeemValue(value, field) {
  return {
    type: types.CUSTOMER_OVERVIEW_CHANGE_REDEEM_VALUE,
    value,
    field
  };
}

export function validateRedeemValue(payload) {
  return {
    type: types.CUSTOMER_OVERVIEW_VALIDATE_REDEEM_VALUE,
    payload
  };
}

export function resetForm() {
  return {
    type: types.CUSTOMER_OVERVIEW_RESET_FORM,
  };
}

export function openConfirmModal() {
  return {
    type: types.CUSTOMER_OVERVIEW_OPEN_CONFIRM_MODAL,
  };
}

export function closeConfirmModal() {
  return {
    type: types.CUSTOMER_OVERVIEW_CLOSE_CONFIRM_MODAL,
  };
}

export function redeemVoucher() {
  return {
    type: types.CUSTOMER_OVERVIEW_REDEEM_VOUCHER,
  };
}

export function redeemVoucherSuccess(payload) {
  return {
    type: types.CUSTOMER_OVERVIEW_REDEEM_VOUCHER_SUCCESS,
    payload,
  };
}

export function withdrawalBalanceLogs(payload) {
  return {
    type: types.CUSTOMER_OVERVIEW_WITHDRAWAL_BALANCE_LOG_SUCCESS,
    payload,
  };
}
